// Version : 0.0.3
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : ADDED COMMENTS AND REMOVED UNUSED LINES
// MODFIED DATE: 07-12-2025

/* eslint-disable import/no-anonymous-default-export */
import { docodeHexResponse } from '../../_common/common.utils';
import AccountDayBookReportActionTypes from './day-book-report.types';

const INITIAL_STATE = {
	fetchDayBookReportResponse: null,
	fetchDayBookReportArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		// Fetch day book report reponse success - Start
		case AccountDayBookReportActionTypes.FETCH_DAY_BOOK_REPORT_SUCCESS:
			return {
				...state,
				fetchDayBookReportResponse: action.payload,
				fetchDayBookReportArr: docodeHexResponse(
					action.payload,
					'FetchBranchAccountDetailsKey',
				),
			};
		// Fetch day book report reponse success - End

		// Fetch day book report response failure - start
		case AccountDayBookReportActionTypes.FETCH_DAY_BOOK_REPORT_FAILURE:
			return {
				...state,
				fetchDayBookReportResponse: action.payload,
				fetchDayBookReportArr: [],
			};
		// Fetch day book report response failure - End

		// Fetch day book report response changed - Start
		case AccountDayBookReportActionTypes.FETCH_DAY_BOOK_REPORT_RESPONSE_CHANGED:
			return {
				...state,
				fetchDayBookReportResponse: null,
			};
		// Fetch day book report response changed - End
		default:
			return state;
	}
};
